export default {
    apiKey: "AIzaSyB8uuM4vvFqBHG-rQEqqiSGFq5EnDSqqIk",
    authDomain: "payments-stage.firebaseapp.com",
    databaseURL: "https://payments-stage.firebaseio.com",
    projectId: "payments-stage",
    storageBucket: "payments-stage.appspot.com",
    messagingSenderId: "994198404528",
    appId: "1:994198404528:web:606da444d1a2322ee22a75",
    measurementId: "G-NFDN39XQMS"
};